import React from 'react';
import './Spinner.css';
import box from '../images/box.svg';
import imageGroup from "../images/groups.svg";

const Spinner = () => {
    return (
        <div className="spinner-container">
            <div className="splash-background">
                <div className="loader"></div>
                <img src={box} alt="box" className="inner-icon" />
            </div>
            <p className="loading-text">Загрузка...</p>
        </div>
    );
};

export default Spinner;